import { Enviroment } from "../../../enviroments";
import { Api } from "../axios-config"
import CookieService from "../../autenticacao/CookieService";

export interface IDetalheJogador {

    codigo: number;
    nome: string;
    capital: number;
    codEstado: number;

}

export interface IListagemJogador {
    codigo: number;
    nome: string;
    ativo: boolean;
    codigo_NBA: number;
    foto: string; //"https://cdn.nba.com/headshots/nba/latest/1040x760/1630173.png"        
    primeiro_Nome: string; // " Precious"    
    situacao: number;
    ultimo_Nome: string;
    posicao_1: string;
    posicao_2: string;
    posicao_3: string;
    franquia_Direito_Liga: string;
    valor_Ultimo_Lance: string;
    tempo_Contrato_Ultimo_Lance: number;
    codigo_Franquia_Ultimo_Lance: number;
    franquia_Ultimo_Lance: string;
    quantidade_Lance_Jogador: number;
    codigo_Franquia_Direito_Liga: number;
    franquia_Atual: string;
    franquia_Atual_Liga: string;
    restrito:boolean;
    draftado: boolean;

}


export interface IDadosRetornoJogador {
    dado: IListagemJogador[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosRetornoEdicao {
    dado: IDetalheJogador;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

interface RespostaCreate {
    statusHTTP: number;
    status: number;
    processado: boolean;
    erros: string;
    mensagem: string;
    dado: number;
}

type TJogadoresComTotalCount = {
    data: IDadosRetornoJogador;
    totalCount: number;
}

export interface IDadosEstatisticas {
    codigo: number;
    codigo_NBA: number;
    nome: string;
    foto?: string;
    arremessos: number;
    lance_Livre: number;
    tres_Pontos: number;
    pontos: number;
    rebotes: number;
    rebotes_Ofensivos: number;
    rebotes_Defensivos: number;
    assistencias: number;
    steal: number;
    bloqueios: number;
    turnovers: number;
    faltas: number;
    minutos: number;
    min_Plus: number;
    quantidade_Jogos: number;
    porcentagem_Arremessos: number;
    porcentagem_Lance_Livre: number;
    porcentagem_Tres_Pontos: number;
    peso_Total_Jogador: number;
    arremessos_Tentativas: number;
    lance_Livre_Tentativas: number;
    tres_Pontos_Tentativas: number;
    lance_Livre_Errados?:number;
    arremessos_Errados?:number;
    tres_Pontos_Errados?:number;
    stocks?:number;
}


export interface IDadosRetornoJogadoresEstatisticas {
    dado: IDadosEstatisticas[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDetalheJogadorFreeAgency {
    codigo?: number;
    codigo_Franquia: number;
    codigo_Jogador: number;
    codigo_Free_Agency: number;
    valor: string;
    tempo_Contrato: number;
    codUsuCriacao?: number;
    codigo_Tipo_Contrato_Ajustavel?: number | null
    valor_Ajustavel_Ano1?: string| null;
    valor_Ajustavel_Ano2?: string| null;
    valor_Ajustavel_Ano3?: string| null;
    valor_Ajustavel_Ano4?: string| null;
    valor_Ajustavel_Ano5?: string| null;
}



export interface IListagemJogadorFranquia {
    codigo: number;
    ativo: boolean;
    codigo_Franquia: string;
    dtCriacao: Date;
    nome_Jogador: string;
    foto_Jogador: string;
    posicao_Jogador: string;
    posicao_1: string;
    posicao_2: string;
    posicao_3: string;
    salario_1: string;
    salario_2: string;
    salario_3: string;
    salario_4: string;
    salario_5: string;
    contundido: boolean;
    restrito: boolean;
    fora_NBA: boolean;
    draftado: boolean;

}

export interface IDadosRetornoJogadoresFranquia {
    dado: IDetalheFranquia;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDetalheFranquia {
    codigo: number;
    nome: string;
    cidade: number;
    franquia_Franquia: string;
    codigo_Usuario: number;
    nome_Usuario: string;
    codUsuCriacao: number;
    codigo_liga: number;
    caminho_Logo: string;
    logo: string;
    dtCriacao: Date;
    situacao: number;
    capacidade_Maxima: string;
    espaco_Maximo: string;
    uniforme: string; //imagem
    codigo_Divisao: number;
    comissario: boolean;
    franquia_Jogador: IDadosFranquiaJogador[];
    franquia_Titulos: IDadosTitulosJogador[];
    franquia_Multas_Anual: IDadosFranquiaMultasAnual;
    codUsuModificacao?: number;
    irregularidades: string[];
    resumo_Picks_Ano1: IDadosResumoPicksAno[];
    resumo_Picks_Ano2: IDadosResumoPicksAno[];
    resumo_Picks_Ano3: IDadosResumoPicksAno[];
    resumo_Picks_Ano4: IDadosResumoPicksAno[];
    resumo_Picks_Ano5: IDadosResumoPicksAno[];
    codigo_Temporada: number;
}

export interface IDadosResumoPicksAno {
    codigo: number;
    swap: boolean;
    protecao: boolean;
    resumo: string;
}

export interface IDadosFranquiaMultasAnual {
    multa_Ano1: string;
    multa_Ano2: string;
    multa_Ano3: string;
    multa_Ano4: string;
    multa_Ano5: string;

}

export interface IDadosFranquiaJogador {
    codigo_Franquia: number;
    codigo_Jogador: number;
    nome_Jogador: string;
    foto_Jogador: string;
    posicao_Jogador: string;
    salario_1: string;
    salario_2: string;
    salario_3: string;
    salario_4: string;
    salario_5: string;
    tipo_Salario_1: number;
    tipo_Salario_2?: number;
    tipo_Salario_3?: number;
    tipo_Salario_4?: number;
    tipo_Salario_5?: number;
    posicao_1: string;
    posicao_2: string;
    posicao_3: string;
    contundido: boolean;
    dtContusao: Date;
    dtRetorno_Contusao: Date;
    draftado: boolean;
    fora_NBA: boolean;
    restrito: boolean;    
    dtCriacao: Date;
    codUsuCriacao: number;
}


export interface IDadosTitulosJogador {
    codigo: number;
    codigo_Franquia: number;
    codigo_Temporada: number;
    codigo_Divisao?: number;
    codigo_Conferencia?: number;
    codigo_Liga?: number;
    dtCriacao: Date;
    codUsuCriacao: number;
}

export interface IDadosFranquiaMultasAnual {
    multa_Ano1: string;
    multa_Ano2: string;
    multa_Ano3: string;
    multa_Ano4: string;
    multa_Ano5: string;

}

export interface IDadosRetornoJogadoresResumido {
    dado: IDadosJogadorResumido[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosJogadorResumido {
    codigo: number;
    codigo_NBA: number;
    nome: string;
}

export interface IDadosRetornoJogadorEstatisticas {
    dado: IDadosEstatisticas;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosSalariosJogadores {
    dado: IDadosExportSalarios[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosExportSalarios {
    //codigo: number;
    Nome: string;
    //codigo_Temporada: number;
    Descricao_Temporada: string;
    Salario: string;
    // salario_2: string;
    // salario_3: string;
    // salario_4: string;
    // salario_5: string;
    // salario_6: string;
    //valor_Total: string;
    //situacao: string;

}

export interface IDadosImportarSalarios {
    rodada: number;
    escolha_Rodada: number;
    escolha_Geral: number;
    salario: string;
    codigo_Temporada: number;
    tempo_Contrato: number;
    restrito: boolean;

    // salario_2: string;
    // salario_3: string;
    // salario_4: string;
    // salario_5: string;
    // salario_6: string;
    //valor_Total: string;
    //situacao: string;

}

export interface IDadosUltimosContratos {
    nome_Franquia: string;
    Ano1: string;
    Ano2: string;
    Ano3: string;
    Ano4: string;
    Ano5: string;
}

export interface IDadosHistoricoJogador {
    codigo: number;
    data: Date;
    descricao: string;
    tipoAcao: string;
}

export interface IDadosRetornoTrocaPosicaoDetalhes {
    dado: IDadosDetalhesTrocaPosicao;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosDetalhesTrocaPosicao {
    codigo_Jogador: number;
    codigo_Jogador_NBA: number;
    nome_Jogador: string;    
    foto_Jogador: string;
    codigo_Franquia_NBA: number;
    nome_Franquia_NBA: string;
    codigo_Franquia_Liga: number;
    nome_Franquia_Liga: string;
    logo_Franquia_Liga: string;
    posicao_1: string;
    posicao_2: string;
    posicao_3: string;
    contundido: boolean;
    restrito: boolean;
    codigo_Franquia_Contrato: number;
    Nome_Franquia_Contrato: string;
    logo_Franquia_Contrato: string;
    ano_Contrato_1: string;
    ano_Contrato_2: string;
    ano_Contrato_3: string;
    ano_Contrato_4: string;
    ano_Contrato_5: string;
    ano_Contrato_6: string;
    media_NBA: IDadosMediaTrocaPosicao[];
    media_Liga: IDadosMediaTrocaPosicao[];
    historico_Liga: IDadosHistoricoLiga[];
    ultimos_Contratos_Liga: IDadosUltimosContratosTrocaPosicao[];
    data: Date;
    descricao: string;
    tipoAcao: string;
    historico_Titulo: IDadosHistoricoTitulo[];
    posicoes_Apta_NBA: string[];
    fora_NBA: boolean;
    meta_Jogador_Player_Option: IDadosMetaJogador[];
    peso_Total: number;
    peso_Total_Minutos: number;
    media_Minutos: number;

}

export interface IDadosMetaJogador{
    codigo: number;
    descricao_Item_Player_Option: string;
    atingida: boolean;
    pontuacao: number;
    quantidade_Meta: number;
    quantidade_Atingida: number;
    descricao_Temporada: string;
}



export interface IDadosHistoricoTitulo {
    codigo: number;
    codigo_Jogador: number;
    codigo_Temporada: number;
    codigo_Liga: number;
    codigo_Franquia: number;
    quantidade_Jogos: number;
    divisao: boolean;
    conferencia : boolean;
    liga: boolean;
    codUsuCriacao: number;
    dtCriacao: Date;
    nome_Jogador: string;
    foto_Jogador: string;
    descricao_Temporada: string;
    nome_Liga: string;
    logo_Liga: string;
    nome_Franquia: string;
    logo_Franquia: string;
}

export interface IDadosMediaTrocaPosicao {
    codigo: number;
    codigo_NBA: number;
    nome: string;
    foto?: string;
    codigo_Temporada_Calouro: number;
    descricao_Temporada: string;
    codigo_Temporada: number;
    arremessos: number;
    lance_Livre: number;
    tres_Pontos: number;
    pontos: number;
    rebotes: number;
    rebotes_Ofensivos: number;
    rebotes_Defensivos: number;
    assistencias: number;
    steal: number;
    bloqueios: number;
    turnovers: number;
    faltas: number;
    minutos: number;
    min_Plus: number;
    quantidade_Jogos: number;
    porcentagem_Arremessos?: number;
    porcentagem_Lance_Livre?: number;
    porcentagem_Tres_Pontos?: number;
    peso_Total_Jogador?: number;
    arremessos_Tentativas: number;
    lance_Livre_Tentativas: number;
    tres_Pontos_Tentativas: number;
    lance_Livre_Errados?:number;
    arremessos_Errados?:number;
    tres_Pontos_Errados?:number;
    stocks?:number;
    peso_Total: number;
    peso_Total_Minutos: number;
    media_Minutos: number;
}


export interface IDadosHistoricoLiga {
    descricao: string;
    dtCriacao: Date;
}

export interface IDadosUltimosContratosTrocaPosicao {
    codigo: number;        
    nome: string;    
    codigo_Franquia: number;
    nome_Franquia: string;
    ano_Contrato_1: string;
    ano_Contrato_2: string;
    ano_Contrato_3: string;
    ano_Contrato_4: string;
    ano_Contrato_5: string;
    ano_Contrato_6: string;
}

export interface IDadosSalvarTrocaPosicao {
    codigo_Jogador: number;
    codigo_Franquia: number;    
    posicao_1: string;
    posicao_2?: string;
    posicao_3?: string;
    contundido: boolean;
    restrito: boolean;
    fora_NBA: boolean;
    codUsuModificacao: number;
}

export interface IDadosEstatisticasJogo {
    codigo: number;
    codigo_NBA: number;
    codigo_Franquia_Nba_Mandante: number;
    codigo_Franquia_Nba_Visitante: number;
    nome_Franquia_Nba_Mandante: string;
    nome_Franquia_Nba_Visitante: string;
    sigla_Franquia_Nba_Mandante: string;
    sigla_Franquia_Nba_Visitante: string;
    logo_Franquia_Nba_Mandante: string;
    logo_Franquia_Nba_Visitante: string;
    placar_Mandante?: number;
    placar_Visitante?: number;
    data_Inicio: string;
    codigo_Temporada: number;
    codUsuCriacao: number;
    dtCriacao: Date;
    rodada_Iniciada: boolean;
    pontuacao_Jogadores_Franquia_Mandante: IDadosEstatisticas[] 
    pontuacao_Jogadores_Franquia_Visitante: IDadosEstatisticas[]    
}


export interface IDadosRetornoJogadoresEstatisticasJogo {
    dado: IDadosEstatisticasJogo;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}


export interface IDadosRetornoJogadoresComparacao {
    dado: IDadosComparacao;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosComparacao {
    codigo: number;
    codigo_NBA: number;
    nome: string;
    foto: string;
    codigo_Franquia_NBA: number;
    nome_Franquia_NBA: string;
    logo_Franquia_NBA: string;
    codigo_Franquia: number;
    nome_Franquia: string;
    logo_Franquia: string;
    posicao_1: string;
    posicao_2: string;
    posicao_3: string;
    ast?: number;
    blk?: number;
    dreb?: number;
    fga?: number;
    fgm?: number;
    fgmp?: number;
    fta?: number;
    ftm?: number;
    ftmp?: number;
    min?: number;
    mplu?: number
    ordem?: number;
    oreb?: number;
    peso_Total_Jogador?: number;
    pf?: number;
    posicao_Liga?: string;
    posicao_Original?: string;
    pts?: number;
    quantidade_Jogos?: number;
    reb?: number;
    stl?: number;
    threepa?: number;
    threepm?: number;
    threepmp?: number;
    to?: number;
    fte?:number;
    fge?:number;
    threepe?:number;
    stocks?:number;  
    titulos_Liga: IDadosHistoricoTitulo[];
    titulos_Geral: IDadosHistoricoTitulo[];

}


export interface IDadosRetornoLesionados {
    dado: IDadosLesionados[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosLesionados {
    codigo_Franquia: number;
    nome_Franquia: string;
    logo_Franquia: string;
    jogadores: IDadosJogadoresLesionados[]
}

export interface IDadosJogadoresLesionados {
    codigo: number;
    codigo_Jogador: number;
    tipo: string;
    info_Adicional: string;
    situacao: string;
    data: Date;
    data_Retorno: string;    
    recuperado: boolean;
    codUsuCriacao: number;
    dtCriacao: Date;
    nome_Jogador: string;
    foto_Jogador: string;
    posicao1_Jogador: string;
    posicao2_Jogador: string;
    posicao3_Jogador: string;
    codigo_Franquia: number;
    nome_Franquia: string;
    logo_Franquia: string;
}




export interface IListaJogadoresRemovidos {
    codigo: number;
    codigo_Liga: number;
    codigo_Jogador: number;
    dtCriacao: Date;
    codUsuCriacao: number;
    nome_Jogador: string;
    foto_Jogador: string;
    posicao_Jogador: string;    
    codigo_Franquia: number;
    nome_Franquia: string;
    logo_Franquia: string;
    nome_Usuario: string;
}

export interface IDadosRetornoJogadoresSemContratoRemovidos {
    dado: IListaJogadoresRemovidos[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}



const getAll = async (page = 1, filter = '', id = 0, posicao = 0, codigo_franquia_atual = 0): Promise<TJogadoresComTotalCount> => {
    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get("/jogador/sql", {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo: id > 0 ? id : null,
            Posicao: posicao > 0 ? posicao : null,
            Codigo_Franquia_Atual: codigo_franquia_atual > 0 ? codigo_franquia_atual : null,
            NumeroPagina: page,
            TamanhoPagina: 1000,
            Filtro: null,
            Filtro2: filter
        }
    });

    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getTodosJogadores = async (codigoLiga: number, codigoJogador: number = 0 ,codigoFranquiaNBA: number = 0, codigoFranquiaLiga: number = 0, posicao: string = "", ativo: number = 1): Promise<TJogadoresComTotalCount> => {
    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/jogador/liga`,  {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo_Liga: codigoLiga,
            Codigo: codigoJogador > 0 ? codigoJogador : null,
            Posicao: posicao === "0" ? null : posicao,
            codigo_Franquia_NBA: codigoFranquiaNBA > 0 ? codigoFranquiaNBA : null,
            codigo_Franquia_Liga: codigoFranquiaLiga,
            Ativo: ativo === 0 ? null : ativo === 1 ? true : false ,
        }
    });

    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getAllPorLiga = async (codigoLiga: number, codigoJogadorFiltro: number = 0, posicaoFiltro: string, codigofranquiaDireitoFiltro: number = 0, codigofranquiaLanceFiltro: number = 0): Promise<TJogadoresComTotalCount> => {
    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/jogador/freeagency`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            codigo_Liga: codigoLiga,
            codigo: codigoJogadorFiltro === 0 ? null : codigoJogadorFiltro,                           
            posicao: posicaoFiltro === "" ? null : posicaoFiltro,
            codigo_franquia_Direito: codigofranquiaDireitoFiltro === 0 ? null : codigofranquiaDireitoFiltro,
            codigo_franquia_Lance: codigofranquiaLanceFiltro === 0 ? null : codigofranquiaLanceFiltro
           }
    });
    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getAllPorFranquia = async (codigoFranquia: number): Promise<IDadosRetornoJogadoresFranquia> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoJogadoresFranquia>(`/jogador/buscarjogadorfranquia/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getJogadorComparacaoPorCodigo = async (codigoJogador: number, codigoLiga: number, codigoTemporada: number): Promise<IDadosRetornoJogadoresComparacao> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoJogadoresComparacao>(`/jogador/stats/comparacao/${codigoJogador}/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getBuscarTodoDraftTemporada = async (codigoLiga: number, codigoTemporada: number): Promise<TJogadoresComTotalCount> => {
    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/liga/draft/jogador/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getBuscarTodoDraftInicialTemporada = async (codigoLiga: number, codigoTemporada: number): Promise<IDadosRetornoJogadoresEstatisticas> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoJogadoresEstatisticas>(`/draft/inicial/jogador/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getBuscarTodoDraftInicialResumidoTemporada = async (codigoLiga: number, codigoTemporada: number): Promise<IDadosRetornoJogadoresResumido> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoJogadoresResumido>(`/draft/inicial/jogador/resumido/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getBuscarDadosJogadorInicial = async (codigoLiga: number, codigoTemporada: number, codigoJogador: number): Promise<IDadosRetornoJogadorEstatisticas> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoJogadorEstatisticas>(`/draft/jogador/stats/${codigoLiga}/${codigoTemporada}/${codigoJogador}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getEstatisticasJogador = async (codigoliga: number, codigoTemporada: number = 1): Promise<IDadosRetornoJogadoresEstatisticas> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoJogadoresEstatisticas>(`/jogador/stats/${codigoliga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getById = async (codigo: number): Promise<IDetalheJogador> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDetalheJogador>(`/jogador/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getDadosSalariosTemporada = async (codigoLiga: number, codigoTemporada: number): Promise<IDadosSalariosJogadores> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosSalariosJogadores>(`/jogador/salariosnba/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getDadosJogadorPorLigaFranquia = async (codigoJogador: number, codigoliga: number, codigoFranquia: number = 1): Promise<IDadosRetornoTrocaPosicaoDetalhes> => {

    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");   
    const { data } = await Api.get<IDadosRetornoTrocaPosicaoDetalhes>(`/trocaposicao/detalhes/${codigoliga}/${user.codUsuario}/${codigoJogador}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getDadosHistoricoJogadorLiga =async (codigoJogador: number, codigoliga: number) => {
    const token = CookieService.get("access_token");
    //const user = CookieService.get("access_user");

    const { data } = await Api.get(`/jogador/historico/liga/${codigoJogador}/${codigoliga}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}


const getEstatisticasJogadorPorJogo = async (codigoJogo: number): Promise<IDadosRetornoJogadoresEstatisticasJogo> => {    
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoJogadoresEstatisticasJogo>(`jogonba/jogadores/pontuacao/${codigoJogo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getCarregarJogadoresRemovidos = async (codigoliga: number, codigoTemporada: number): Promise<IDadosRetornoJogadoresSemContratoRemovidos> => {

    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");   
    const { data } = await Api.get<IDadosRetornoJogadoresSemContratoRemovidos>(`/jogador/dispensado/todos/${codigoliga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const Create = async (dados: Omit<IDetalheJogador, "codigo">): Promise<number> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.post<RespostaCreate>(`/jogador`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    if (data.processado) {
        return data.dado;
    }
    return 0;
}


const CreateJogadorFreeAgency = async (dados: Omit<IDetalheJogadorFreeAgency, "codigo">): Promise<number> => {
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");
    dados.codUsuCriacao = user.codUsuario;

    const { data } = await Api.post<RespostaCreate>(`/freeagency/lance`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    if (data.processado) {
        return data.dado;
    }
    return 0;
}


const updateById = async (codigo: number, dados: IDetalheJogador): Promise<void> => {
    const token = CookieService.get("access_token");
    await Api.put<IDetalheJogador>(`/jogador/${codigo}`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}


const updatePosicaoJogador = async (dados: IDadosSalvarTrocaPosicao): Promise<void> => {
    const token = CookieService.get("access_token");
    await Api.put<IDetalheJogador>(`/trocaposicao/jogador`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const deleteById = async (codigo: number): Promise<void> => {
    const token = CookieService.get("access_token");
    await Api.delete(`/jogador/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}


const getJogadoresLesionadosNBA = async (codigoLiga: number): Promise<IDadosRetornoLesionados> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoLesionados>(`/jogador/lesionado/nba/${codigoLiga}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getJogadoresLesionadoLiga = async (codigoLiga: number): Promise<IDadosRetornoLesionados> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoLesionados>(`/jogador/lesionado/liga/${codigoLiga}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}


const deleteRemoverJogadores = async (codigoLiga: number, codigoUsuario: number): Promise<void> => {
    const token = CookieService.get("access_token");
    await Api.delete(`/jogador/todos/semcontrato/${codigoLiga}/${codigoUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}


export const JogadorService = {
    getAll,
    getById,
    Create,
    updateById,
    deleteById,
    getEstatisticasJogador,
    CreateJogadorFreeAgency,
    getAllPorLiga,
    getBuscarTodoDraftTemporada,
    getAllPorFranquia,
    getBuscarTodoDraftInicialTemporada,
    getBuscarTodoDraftInicialResumidoTemporada,
    getBuscarDadosJogadorInicial,
    getDadosSalariosTemporada,
    getDadosJogadorPorLigaFranquia,
    getDadosHistoricoJogadorLiga,
    updatePosicaoJogador,
    getTodosJogadores,
    getEstatisticasJogadorPorJogo,
    getJogadorComparacaoPorCodigo,
    getJogadoresLesionadosNBA,
    getJogadoresLesionadoLiga,    
    deleteRemoverJogadores,
    getCarregarJogadoresRemovidos

}